import React, { useLayoutEffect, useState, useContext } from 'react';

import * as S from './styles';
import AddBtn from 'components/AddBtn';
import { BannerFromCarrosselBannersProps } from 'types/BannerFromCarrosselBannersProps';
import FormAddBanner, {
	DataFormAddBannerProps
} from 'components/FormAddBanner';
import { DataFormCarroselBannersProps } from 'types/DataFormCarroselBannersProps';
import DynamicPageContext from 'context/DynamicPage';
import { SelectInputItemProps } from 'types/SelectInputItemProps';
import { returListOptionsDynamicPage } from './functions';
import { getImageDimensions } from 'utils/functions';
import ListDragableBanners from 'components/ListDragableBanners';

interface AddBannersInListProps {
	isShow: boolean;
	dataForm: DataFormCarroselBannersProps;
	setDataForm: React.Dispatch<
		React.SetStateAction<DataFormCarroselBannersProps>
	>;
	bannerWithDescription?: boolean;
}

//esse componente é usado para carrossel de banners e banners com descrição NÃO REAPROVEITAR MAIS DO QUE ISSO

export default function AddBannersInList({
	isShow,
	setDataForm,
	bannerWithDescription = false
}: AddBannersInListProps) {
	const { moduleInSavingMode, moduleOnPhoneToEdit, dynamicPagesList } =
		useContext(DynamicPageContext);
	const [isFormBannerOpen, setIsFormBannerOpen] = useState(false);
	const [listBanners, setListBanners] = useState<
		BannerFromCarrosselBannersProps[]
	>([]);
	const [bannerToEdit, setBannerToEdit] =
		useState<BannerFromCarrosselBannersProps | null>(null);
	const [optionsDynamicScreen, setOptionsDynamicScreen] = useState<
		SelectInputItemProps[]
	>([]);
	const [sizeBanner, setSizeBanner] = useState({ width: 9999, height: 9999 });

	function addNewBanner(banner: DataFormAddBannerProps) {
		const newBanner: BannerFromCarrosselBannersProps = {
			idFront: banner.idFront,
			query: banner.query,
			image: {
				id: banner.banner?.id || '',
				relativePath: banner.banner?.relativePath || ''
			},
			redirect: {
				type: banner.redirectType,
				value: banner.redirectValue
			}
		};

		if (bannerWithDescription) {
			newBanner.description = banner.description;
		}

		if (banner?.rne && banner.rne !== '') {
			newBanner.rne = banner.rne;
		}

		if (
			banner.schedule &&
			(banner.schedule.start !== '' || banner.schedule.end !== '')
		) {
			newBanner.schedule = {
				countdown: banner.schedule.countdown,
				start: banner.schedule.start,
				end: banner.schedule.end,
				timezone: banner.schedule.timezone
			};
		} else {
			delete newBanner.schedule;
		}
		setListBanners((obj) => [...obj, newBanner]);
		setIsFormBannerOpen(false);
	}

	function editBanner(bannerEdited: DataFormAddBannerProps) {
		const newList = listBanners.map((item) => {
			if (item.idFront === bannerToEdit?.idFront) {
				const newBanner: BannerFromCarrosselBannersProps = {
					idFront: bannerEdited.idFront,
					query: bannerEdited.query,
					image: {
						id: bannerEdited.banner?.id || '',
						relativePath: bannerEdited.banner?.relativePath || ''
					},
					redirect: {
						type: bannerEdited.redirectType,
						value: bannerEdited.redirectValue
					}
				};

				if (bannerWithDescription) {
					newBanner.description = bannerEdited.description;
				}

				if (bannerEdited?.rne && bannerEdited.rne !== '') {
					newBanner.rne = bannerEdited.rne;
				}

				if (
					bannerEdited.schedule &&
					(bannerEdited.schedule.start !== '' ||
						bannerEdited.schedule.end !== '')
				) {
					newBanner.schedule = {
						countdown: bannerEdited.schedule.countdown,
						start: bannerEdited.schedule.start,
						end: bannerEdited.schedule.end,
						timezone: bannerEdited.schedule.timezone
					};
				} else {
					delete newBanner.schedule;
				}
				return newBanner;
			}

			return item;
		});
		setListBanners(newList);
		setIsFormBannerOpen(false);
		setBannerToEdit(null);
	}

	function deleteBanner(id: string | number) {
		const newList = listBanners.filter((item) => item.idFront !== id);
		setListBanners(newList);
	}

	function returnNameRedirectByIdDynamicScreen(id: string) {
		const item = optionsDynamicScreen.filter((item) => item.id === id);
		return item.length > 0 ? item[0].option : 'Não encontrado';
	}

	//sempre adiciona o banner no estado de dataForm
	useLayoutEffect(() => {
		const newList = listBanners.map((item) => {
			return item;
		});

		setDataForm((obj) => ({ ...obj, banners: newList }));
	}, [listBanners]);

	//pega tamanho da imagem para criar regra do carrossel
	useLayoutEffect(() => {
		(async () => {
			if (listBanners.length > 0) {
				await getImageDimensions(listBanners[0].image.relativePath)
					.then((size) => {
						setSizeBanner({ height: size.height, width: size.width });
					})
					.catch(() => {
						setSizeBanner({ height: 9999, width: 9999 });
					});
			} else {
				setSizeBanner({ height: 9999, width: 9999 });
			}
		})();
	}, [listBanners]);

	//se estiver em edição aqui pega os dados do item editado
	useLayoutEffect(() => {
		if (moduleOnPhoneToEdit !== null && moduleInSavingMode === null) {
			setTimeout(() => {
				setListBanners(moduleOnPhoneToEdit?.data?.banners || []);
			}, 100);
		}
	}, []);

	//cria lista de opções de pagínas dinamicas em um estado para evitar reenderização
	useLayoutEffect(() => {
		setOptionsDynamicScreen(returListOptionsDynamicPage(dynamicPagesList));
	}, []);

	return (
		<S.container $isShow={isShow}>
			<AddBtn
				text="Adicionar Banner"
				anyFunction={() => setIsFormBannerOpen(true)}
			/>

			<ListDragableBanners
				deleteBanner={deleteBanner}
				listBanners={listBanners}
				setListBanners={setListBanners}
				returnNameRedirectByIdDynamicScreen={
					returnNameRedirectByIdDynamicScreen
				}
				setBannerToEdit={setBannerToEdit}
				setIsFormBannerOpen={setIsFormBannerOpen}
				setSizeBanner={setSizeBanner}
			/>

			<FormAddBanner
				useDescription={bannerWithDescription}
				sizeBanner={sizeBanner}
				optionsDynamicScreen={optionsDynamicScreen}
				isOpen={isFormBannerOpen}
				setIsOpen={(value) => {
					setIsFormBannerOpen(value);
					setBannerToEdit(null);
				}}
				banner={bannerToEdit}
				functionToGetDataAboutBanner={
					bannerToEdit === null ? addNewBanner : editBanner
				}
				withTitle={false}
				withRne
			/>
		</S.container>
	);
}
